import { BaseService } from './base';
import { Supplier } from '../models/supplier';

export class SupplierService extends BaseService<Supplier> {
  override model = Supplier;
  override modelName = 'supplier';
  override modelLabel = 'Supplier';
}
